import AclName from '../acl/AclName';
import model from '../models-v2/bookkeeping/kh-template';

export default [
  {
    path: '/admin/templates/kh-templates',
    name: 'admin-kh-templates',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      acl: AclName.SettingsPageTemplatesKhTemplatesList,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Parametry pracy', url: '/admin/templates/kh-templates' },
      ],
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/admin/templates/kh-templates/edit/:id',
    name: 'admin-kh-templates-edit',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      acl: AclName.SettingsPageTemplatesKhTemplatesEdit,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Szablony', url: '' },
        { title: 'Parametry pracy', url: '/admin/templates/kh-templates' },
        { title: 'Edycja', url: '' },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
];
